import { BaseResource } from "./base.resource";

export const WasteStreamAccessLevel = {
  None: 0,
  View: 1 << 0,
  Edit: 1 << 1,
  Delete: 1 << 2,
};

export class WasteStream extends BaseResource {
  active: boolean;
  tsdfProfile: string;
  name: string;
  profileExpiresOn: Date;
  dotDescription: string;
  containerDetail: string;
  corrosive: boolean;
  ignitable: boolean;
  reactive: boolean;
  toxic: boolean;
  hm: boolean;
  physicalState: string;
  specificGravity: number;
  tsdfCode: string;
  facility: string;
  mgmtCode: string;
  formCode: string;
  sourceCode: string;
  processingCategory: string;
  regulatoryStatus: string;
  ergNumber: string;
  constituent1: string;
  percent1: string;
  constituent2: string;
  percent2: string;
  constituent3: string;
  percent3: string;
  constituent4: string;
  percent4: string;
  constituent5: string;
  percent5: string;
  stateWasteCode: string;
  wasteCode01: string;
  wasteCode02: string;
  wasteCode03: string;
  wasteCode04: string;
  wasteCode05: string;
  wasteCode06: string;
  wasteCode07: string;
  wasteCode08: string;
  wasteCode09: string;
  wasteCode10: string;
  rcra: boolean;
  ermRecycleOffsite: boolean;
  ermRecycleOnsite: boolean;
  sb14exempt: boolean;
  triexempt: boolean;
  createdBy: string;
  createdOn: Date;
  updatedBy: string;
  updatedOn: Date;

  constructor(options?: any) {
    super(options);
    // Initialize properties...
  }

  get canView(): boolean {
    return (this.accessLevel & WasteStreamAccessLevel.View) > 0;
  }
  get canEdit(): boolean {
    return (this.accessLevel & WasteStreamAccessLevel.Edit) > 0;
  }
  get canDelete(): boolean {
    return (this.accessLevel & WasteStreamAccessLevel.Delete) > 0;
  }
}
